module.exports = __webpack_public_path__ + "assets/images/ending3_dae4b4a2ac2afb82ee2a0a845a5cc810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending3.png
// module id = 135
// module chunks = 0